import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const BookingDatesCell = ({ row }) => {
  return (
    <div data-testid="booking-dates-cell" className="booking-dates-cell">
      <div className="details">
        <span className="name">
          {row.original.address1} {row.original.address2} {row.original.city}{" "}
          {row.original.state} {row.original.country}
        </span>
      </div>
    </div>
  );
};

BookingDatesCell.propTypes = {
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default BookingDatesCell;
